// extracted by mini-css-extract-plugin
export default {"menuItem":"style_menuItem__-S1UT","red":"style_red__zlDrm","green":"style_green__Xr3WM","yellow":"style_yellow__uwxb5"};